import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import { FaMicrosoft } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { SiMicrosoftoutlook } from 'react-icons/si';
import { GoogleMailIcon } from 'wisestep-base';

const AvatarIcon = styled(Avatar)(() => ({
  backgroundColor: 'transparent',
}));

export const getSocialIcon = (name: string) => {
  switch (name) {
    case 'Google':
      return (
        <AvatarIcon variant="square" alt="Google">
          <FcGoogle />
        </AvatarIcon>
      );
    case 'Microsoft':
      return (
        <AvatarIcon variant="square" alt="Microsoft">
          <FaMicrosoft style={{ color: '#00B4D8' }} />
        </AvatarIcon>
      );
    case 'Outlook':
      return (
        <AvatarIcon variant="square" alt="Google">
          <SiMicrosoftoutlook style={{ color: '#064484' }} />
        </AvatarIcon>
      );
    case 'Gmail':
      return (
        <AvatarIcon variant="square" alt="Gmail" sx={{ height: '22px', width: '24px' }}>
          <GoogleMailIcon />
        </AvatarIcon>
      );
    case 'Mail':
      return (
        <AvatarIcon variant="square" alt="Mail">
          <EmailOutlinedIcon sx={{ color: '#00B4D8' }} />
        </AvatarIcon>
      );
  }
};
